import { TuneVerticalVariantIcon } from './TuneVerticalVariantIcon';

/**
 * author: Colton Wiscombe
 * id FF706504-28DF-4752-BD75-E50FFE794421
 * name tune-vertical-variant
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tune-vertical-variant.svg
 * tags
 * - Audio 
 * - Settings 
 */
export const SliderVerticalIcon = TuneVerticalVariantIcon;
export default SliderVerticalIcon